import React, { FC } from 'react';
import './SkeletonCard.styles.scss';
import classNames from 'classnames';

type SkeletonCardProps = {
  className?: string;
};

const SkeletonCard: FC<SkeletonCardProps> = (props) => {
  const { className } = props;

  return (
    <div className={classNames('skeleton-card', className)}>
      <div className="skeleton-card__title" />
      <div className="skeleton-card__content" />
    </div>
  );
};

export default SkeletonCard;
